import { axios } from "../libs/axios";
import qs from "qs";

export const ExportXlsx = async (name: string, query?: string) => {
  let filter: string | null = null;
  if (query) filter = query;
  else filter = sessionStorage.getItem("Current_list");

  const response = await axios.get(`${name}/export`, {
    params: qs.parse(filter!),
    paramsSerializer: (params) => qs.stringify(params),
    responseType: "blob",
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${name.toLowerCase()}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
